export default "__VITE_ASSET__NfYBTB5q__"